import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import { useLoggedOutAthletePageContext } from '../../../../state/LoggedOutAthletePageContext';
import { getProfileVisibility } from '../../../../helpers/getProfileVisibility';
import styles from './ImageGrid.module.scss';

const ImageGrid = ({ images }) => {
  const { t, track, state } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete } = athleteData;
  const hasImages = images.length > 0;

  const handleTrack = (type) => {
    track({
      action: 'click',
      element: type,
      properties: {
        profile_visibility: getProfileVisibility(athlete)
      }
    });
  };

  const mapSrc = (image) => {
    // If image is primary image (map), check to see if it should render
    // as a square or the default ratio
    return images.length === 2 || images.length === 5
      ? image.squareSrc
      : image.defaultSrc;
  };

  if (!hasImages) {
    return null;
  }

  return (
    <div className={clsx(styles.container, styles[`images${images.length}Up`])}>
      {images.map((image) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          className={styles.imageWrapper}
          key={image.id}
          onClick={() => handleTrack(image.type)}
        >
          <div className={clsx(styles.image, styles[image.type])}>
            <img
              src={image.type === 'map' ? mapSrc(image) : image.defaultSrc}
              alt={
                image.type === 'map'
                  ? t('activity_map_alt', {
                      activity_title: image.caption
                    })
                  : image.caption
              }
            />
          </div>
        </div>
      ))}
    </div>
  );
};

ImageGrid.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      primary: PropTypes.bool,
      caption: PropTypes.string,
      defaultSrc: PropTypes.string,
      squareSrc: PropTypes.string
    })
  )
};

ImageGrid.defaultProps = {
  images: []
};

export default ImageGrid;
